import React from 'react';
import './style.scss';
import { isRTL } from '../../../services/userModel.js';
import classNames from 'classnames';
import { getTranslateTitle } from '../../../utils/objects-util.js';
import EditableTable from '../EditableTable/EditableTable.jsx';
import { connect } from 'react-redux';
import preloader from "../../../assets/images/preloader.GIF";
import { CONTROL_TYPE } from '../../../utils/enums.js';
import { getOrderSource } from '../../../utils/order.js';

const SectionItemSkuOverride = ({ t, item, column, onPropChange, isLoading, translationsLanguage }) => {
  const columnsCount = 1 + item?.providers?.length;
  const columnsWidth = 100 / columnsCount;

  const newColumns = column.columns.map(c => ({...c, width: `${columnsWidth}%`, fixedWidth: `${columnsWidth}%`})).concat(item?.providers?.map(source => ({
    title: source ? getOrderSource(source) : 'settings.sku_override.NEW_SKU',
    accessor: `sku-${source}`,
    width: `${columnsWidth}%`,
    fixedWidth: `${columnsWidth}%`,
    markWhenDirty: true,
    showInherited: item => item[`sku-${source}`] === item[`inherited-${source}`],
    type: CONTROL_TYPE.inputText,
  }))).filter(Boolean);

  return (
    <div className={classNames('sectionItemSkuOverride', { rtl: isRTL() })}>
      <table className={classNames('header')}>
        <tbody>
          <tr>
            {newColumns?.map((column, index) => {
              return (
                <td
                  key={`headerItem-${column.title}-${index}`}
                  className={classNames('headerItem', {
                    centered: column.centered,
                  })}
                  style={{
                    width: column.width ? `${column.width}` : `auto`,
                    textAlign: column.textRight ? 'right' : '',
                  }}
                >
                  {getTranslateTitle(column.title)}
                  &nbsp;
                </td>
              );
            })}
          </tr>
        </tbody>
      </table>
      {isLoading && (
        <div className={classNames('loaderWrapper')}>
          <img className='preloader' src={preloader} alt='preloader' />
        </div>
      )}
      <EditableTable virtualized model={{...column, columns: newColumns}} items={item?.values} isTranslationRtl={translationsLanguage === "he" || translationsLanguage === "ar"} isLoading={false} onPropChange={onPropChange} />
    </div>
  );
};

const mapStateToProps = state => {
  return {
    isLoading: state.sectionsWrapperData.isLoading,
      translationsLanguage: state.restaurant?.data?.translations?.language
  };
};

export default connect(mapStateToProps)(SectionItemSkuOverride);
